import { Editor } from "slate";
import { CustomText } from "./slateTypes";

type MarkFormat = keyof Omit<CustomText, "text">;

export const isMarkActive = (editor: Editor, format: MarkFormat) => {
    const marks = Editor.marks(editor);
    return marks ? marks[format] === true : false;
};

export const toggleMark = (editor: Editor, format: MarkFormat) => {
    const isActive = isMarkActive(editor, format);
    if (isActive) {
        Editor.removeMark(editor, format);
        return;
    }
    Editor.addMark(editor, format, true);
};
